module.exports = __webpack_public_path__ + "static/media/zxs_kc.dc61160a.png";